import { useLayoutEffect } from 'react';
/** Grows a textarea with its content up to `maxHeight`, then scrolls. */
export function useAutoResize(ref, value, maxHeight = 140) {
    useLayoutEffect(() => {
        const node = ref.current;
        if (!node)
            return;
        node.style.height = 'auto';
        node.style.height = `${Math.min(node.scrollHeight, maxHeight)}px`;
        node.style.overflowY = node.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }, [ref, value, maxHeight]);
}
